<ng-container
  *ngIf="{
    counterResultRequest: counterResultRequest$ | async,
  } as content"
>
  <div class="container-plp-counter">
    @if (!content.counterResultRequest?.isLoading) {
      @if (!content.counterResultRequest?.hasError) {
        @if (content.counterResultRequest?.results?.length) {
          <ul>
            <li *ngFor="let item of content.counterResultRequest?.results">
              <a [routerLink]="[item.path, currentTerm]" class="btn {{ item.class }}" [ngClass]="{ disabled: item.disabled }">
                ({{ item.qty }}) {{ item.label }}
              </a>
            </li>
          </ul>
        }
      } @else {
        <alert [alert]="errorMessage"></alert>
      }
    } @else {
      <local-loader></local-loader>
    }
  </div>
</ng-container>
